import { IContactConnection, useLazyGetConnectionsQuery } from "./contactConnectionsApi"
import { useEffect, useState } from "react"
import { useAuth } from "../../../modules/auth"

export const useContactConnections = () => {
    const { user, selectedEntityId: entityId, selectEntityId } = useAuth();
    const [getConnections] = useLazyGetConnectionsQuery();
    const [connections, setConnections] = useState<IContactConnection[] | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        if (!user?.role || !user?.contactId) {
            setLoading(false);
            return;
        }

        const { role, contactId } = user;

        setLoading(true);
        getConnections({ role, contactId })
            .unwrap()
            .then((result) => {
                if (result.length === 1) {
                    selectEntityId(result[0].contactId);
                } else {
                    setConnections(result);
                }
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                setLoading(false);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user?.role, user?.contactId]);

    return { connections, entityId, selectEntityId, loading };
};
